"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasCartesian2dPlotFactory = void 0;
const canvas_cartesian_update_hooks_1 = require("../update/update-arg/canvas-cartesian-update-hooks");
const cartesian2d_plot_ctor_arg_1 = require("./cartesian2d-plot-ctor-arg");
const cartesian_2d_trace_entity_connector_1 = require("../axis/cartesian-2d-trace-entity-connector");
const create_cartesian_plot_ctor_1 = require("./create-cartesian-plot-ctor");
const canvas_cartesian_2d_axis_label_graphics_component_1 = require("../axis/labels/canvas-cartesian-2d-axis-label-graphics-component");
const canvas_cartesian_2d_trace_graphics_component_1 = require("../axis/traces/canvas-cartesian-2d-trace-graphics-component");
const core_1 = require("@visualization-tools/core");
/**
 * @public
 * Provides {@link TCanvasCartesianPlot} for canvas charts.
 */
class CanvasCartesian2dPlotFactory {
    static createOne(chart, options) {
        const plotArea = options.getPlotArea(chart.attachPoint);
        const arg = new cartesian2d_plot_ctor_arg_1.Cartesian2dPlotCtorArg(chart, options, plotArea);
        return new CanvasCartesianPlot(arg);
    }
    static setDefaultAxis(plot, options, chart) {
        const traceConnector = new cartesian_2d_trace_entity_connector_1.Cartesian2dTraceEntityConnector(Float64Array, options.traceOptions.maxTraceCount, plot.changeIdFactory);
        const axisGraphicsComponents = core_1.CompositeGraphicsComponent
            .createOne(new canvas_cartesian_2d_trace_graphics_component_1.CanvasCartesian2dTraceGraphicsComponent())
            .addComponent(new canvas_cartesian_2d_axis_label_graphics_component_1.CanvasCartesian2dAxisLabelGraphicsComponent(chart.attachPoint))
            .build();
        plot.metaCategory.addEntity(new core_1.ChartDataEntity(traceConnector, {
            traceColor: options.traceOptions.traceColor,
            traceLinePixelSize: options.traceOptions.traceLinePixelSize,
            axisOptions: options.axisConfig,
            zIndexRel: 0,
            zIndexAbs: 0,
        }, plot.changeIdFactory, function (arg) {
            this.changeId = this.data.update(arg.plotRange);
        }), axisGraphicsComponents);
    }
}
exports.CanvasCartesian2dPlotFactory = CanvasCartesian2dPlotFactory;
const CanvasCartesianPlot = (0, create_cartesian_plot_ctor_1.createCartesianPlotCtor)(CanvasCartesian2dPlotFactory, new canvas_cartesian_update_hooks_1.CanvasCartesianUpdateHooks(arg => arg.plotDimensionsOTL.pixelArea.wholeRange), new canvas_cartesian_update_hooks_1.CanvasCartesianUpdateHooks(arg => arg.plotDimensionsOTL.pixelArea.interactiveRange));
//# sourceMappingURL=canvas-cartesian2d-plot-factory.js.map